module.exports = __webpack_public_path__ + "img/op_five_steps_1_upload.29fbd4e2.png";